export default "__VITE_ASSET__EcFmTAe8__"